$(document).ready(function () {

    function makeLandscape() {
        // this works on android, not iOS
        if (screen.orientation && screen.orientation.lock) {
            screen.orientation.lock('landscape');
        }
    }

   /* function turnVideoFullScreen(element) {

        if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
            makeLandscape();
        } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
            makeLandscape();
        }

    };
*/

});
